module.exports = __webpack_public_path__ + "img/logo.fea8f465.png";